export const defaultFirebaseConfigurations = {
  revenuecatDefaultOffering: 'dupr_plus_offering_v1',
  revenuecatDefaultApiKey: 'rcb_sb_VlLiXajeFuvzJsFqJXyVJUxkv', // The sandbox key
  stripeApiKey:
    'pk_test_51QegfnFTOuuVhQ3RdjufQxWxTpfuJnI0v6DV1YB6eN6TuhJvvZ5kNsFH5xGwJiCoIVRLsi2A8nZMSNKbDCROk67R009h4VNVZx', // sandbox key
  revCatApiKey: 'rcb_sb_VlLiXajeFuvzJsFqJXyVJUxkv', // sandbox key
  webRevenueCatApiKey: 'rcb_sb_VlLiXajeFuvzJsFqJXyVJUxkv', // sandbox key — overridden by Firebase Remote Config in production
}
